import {
  getFlatEntityListApi,
  createFlatEntityApi,
  editFlatEntityApi,
  deleteFlatEntityApi,
} from "../../api/registry.api";
import { loadDictionaries } from "../../locales";
import callApi from "../../libs/helpers/callApi";

export const FEE_SERVICE_LOADING = "FEE_SERVICE_LOADING";
export const FEE_SERVICE_LOADED = "FEE_SERVICE_LOADED";
export const FEE_SERVICE_LOAD_ERROR = "FEE_SERVICE_LOAD_ERROR";

// FEE_SERVICE GET LIST
export const getFeeServiceAction = callApi({
  apiCall: (p) => getFlatEntityListApi({ ...p, entity: "fee_service" }),
  secured: true,
  startAction: FEE_SERVICE_LOADING,
  successAction: FEE_SERVICE_LOADED,
  errorAction: FEE_SERVICE_LOAD_ERROR,
});

export const FEE_SERVICE_CREATE_LOADING = "FEE_SERVICE_CREATE_LOADING";
export const FEE_SERVICE_CREATE_COMPLETE = "FEE_SERVICE_CREATE_COMPLETE";
export const FEE_SERVICE_CREATE_LOAD_ERROR = "FEE_SERVICE_CREATE_LOAD_ERROR";

// FEE_SERVICE CREATE
export const createFeeServiceAction = callApi({
  apiCall: (p) => createFlatEntityApi(p),
  secured: true,
  startAction: FEE_SERVICE_CREATE_LOADING,
  successAction: FEE_SERVICE_CREATE_COMPLETE,
  errorAction: FEE_SERVICE_CREATE_LOAD_ERROR,
  afterSuccessAction: ({ dispatch, params, result }) => {
    dispatch(getFeeServiceAction());
    loadDictionaries();
  },
});

export const FEE_SERVICE_EDIT_LOADING = "FEE_SERVICE_EDIT_LOADING";
export const FEE_SERVICE_EDIT_COMPLETE = "FEE_SERVICE_EDIT_COMPLETE";
export const FEE_SERVICE_EDIT_LOAD_ERROR = "FEE_SERVICE_EDIT_LOAD_ERROR";

// FEE_SERVICE EDIT
export const editFeeServiceAction = callApi({
  apiCall: (p) => editFlatEntityApi(p),
  secured: true,
  startAction: FEE_SERVICE_EDIT_LOADING,
  successAction: FEE_SERVICE_EDIT_COMPLETE,
  errorAction: FEE_SERVICE_EDIT_LOAD_ERROR,
  afterSuccessAction: ({ dispatch, params, result }) => {
    dispatch(getFeeServiceAction());
    loadDictionaries();
  },
});

export const FEE_SERVICE_DELETE_LOADING = "FEE_SERVICE_DELETE_LOADING";
export const FEE_SERVICE_DELETE_COMPLETE = "FEE_SERVICE_DELETE_COMPLETE";
export const FEE_SERVICE_DELETE_LOAD_ERROR = "FEE_SERVICE_DELETE_LOAD_ERROR";

// FEE_SERVICE DELETE
export const deleteFeeServiceAction = callApi({
  apiCall: (p) => deleteFlatEntityApi(p),
  secured: true,
  startAction: FEE_SERVICE_DELETE_LOADING,
  successAction: FEE_SERVICE_DELETE_COMPLETE,
  errorAction: FEE_SERVICE_DELETE_LOAD_ERROR,
  afterSuccessAction: ({ dispatch, params, result }) => {
    dispatch(getFeeServiceAction());
  },
});
